export const SET_PHOTOS = 'SET_PHOTOS'
export const SET_SORT_BY = 'SET_SORT_BY'

export const SET_SUGGESTIONS = 'SET_SUGGESTIONS'
export const SET_PROPERTY_COMPS = 'SET_PROPERTY_COMPS'
export const SET_PROPERTY_VIEW = 'SET_PROPERTY_VIEW'
export const SET_PROPERTY_STATUSES = 'SET_PROPERTY_STATUSES'
export const SET_DWELLING_TYPES = 'SET_DWELLING_TYPES'
export const SET_COUNTIES = 'SET_COUNTIES'
export const SET_CITIES = 'SET_CITIES'
export const SET_ZIP_CODES = 'SET_ZIP_CODES'
export const SET_HOUSE_SQUARE_FEET = 'SET_HOUSE_SQUARE_FEET'
export const SET_LOT_SQUARE_FEET = 'SET_LOT_SQUARE_FEET'
export const SET_DAYS_SINCE_LISTED = 'SET_DAYS_SINCE_LISTED'
export const SET_PRICES = 'SET_PRICES'
export const SET_PROPERTY_HIGHLIGHT = 'SET_PROPERTY_HIGHLIGHT'
export const SET_SEARCH = 'SET_SEARCH'
export const SET_SAVED_SEARCH_LOADED = 'SET_SAVED_SEARCH_LOADED'
export const SET_SCROLL_POSITION = 'SET_SCROLL_POSITION'

// PROPERTY
export const SET_ACTIVE_PROPERTY_ID = 'SET_ACTIVE_PROPERTY_ID'
export const SET_PROPERTIES = 'SET_PROPERTIES'
export const SET_PROPERTIES_GEO = 'SET_PROPERTIES_GEO'
export const CLEAR_PROPERTIES_GEO = 'CLEAR_PROPERTIES_GEO'
export const CLEAR_PROPERTY = 'CLEAR_PROPERTY'
export const CLEAR_PROPERTIES = 'CLEAR_PROPERTIES'
export const SET_SELECTED_PROPERTIES = 'SET_SELECTED_PROPERTIES'
export const TOGGLE_PROPERTY_ADDRESS_WITHHELD =
  'TOGGLE_PROPERTY_ADDRESS_WITHHELD'
export const SET_TAX_DETAIL_MAP_STATUS_FILTERS_VISIBLE =
  'SET_TAX_DETAIL_MAP_STATUS_FILTERS_VISIBLE'
export const SET_TAX_DETAIL_ACTIVITY_MONTHS = 'SET_TAX_DETAIL_ACTIVITY_MONTHS'
export const SET_TAX_DETAIL_ACTIVITY_FORSALE_RENT =
  'SET_TAX_DETAIL_ACTIVITY_FORSALE_RENT'
export const SET_TAX_DETAIL_ACTIVITY_STATUSES =
  'SET_TAX_DETAIL_ACTIVITY_STATUSES'
export const SET_TAX_DETAIL_MAP_FILTERS_CHANGED =
  'SET_TAX_DETAIL_MAP_FILTERS_CHANGED'
export const TOGGLE_TAX_DETAIL_PROPERTY_STATUS =
  'TOGGLE_TAX_DETAIL_PROPERTY_STATUS'
export const TOGGLE_TAX_DETAIL_PROPERTY_STATUS_SELECT_ALL =
  'TOGGLE_TAX_DETAIL_PROPERTY_STATUS_SELECT_ALL'
export const TOGGLE_TAX_DETAIL_PROPERTY_STATUS_DESELECT_ALL =
  'TOGGLE_TAX_DETAIL_PROPERTY_STATUS_DESELECT_ALL'
export const RESET_TAX_DETAIL_MAP_FILTERS = 'RESET_TAX_DETAIL_MAP_FILTERS'
export const SET_PARCEL = 'SET_PARCEL'
export const SET_MAP_LEGEND_VISIBLE = 'SET_MAP_LEGEND_VISIBLE'
export const TOGGLE_TAX_DETAIL_MAP_FORECLOSURE =
  'TOGGLE_TAX_DETAIL_MAP_FORECLOSURE'
export const SET_LARGE_TAX_DETAIL_MAP = 'SET_LARGE_TAX_DETAIL_MAP'

// MAP
export const TOGGLE_MAP = 'TOGGLE_MAP'
export const MAP_ON_MOVE = 'MAP_ON_MOVE'
export const SET_REGION_COORDINATES = 'SET_REGION_COORDINATES'
export const CLEAR_REGION_COORDINATES = 'CLEAR_REGION_COORDINATES'
export const SET_VIEW_BOUNDS = 'SET_VIEW_BOUNDS'
export const SET_HOVERED_PROPERTY = 'SET_HOVERED_PROPERTY'
export const SET_SELECTED_MINI_CARD_UPI = 'SET_SELECTED_MINI_CARD_UPI'
export const SET_COMMUTE_SHAPE = 'SET_COMMUTE_SHAPE'
export const SET_USER_LOCATION_ENABLED = 'SET_USER_LOCATION_ENABLED'
export const SEARCH_WITHIN_MAP_WINDOW = 'SEARCH_WITHIN_MAP_WINDOW'
export const SET_SEARCH_WITHIN_AS_PREFERENCE = 'SET_SEARCH_WITHIN_AS_PREFERENCE'
export const SET_SHOULD_FIT_BOUNDS_ON_MAP_ONLY =
  'SET_SHOULD_FIT_BOUNDS_ON_MAP_ONLY'
export const SET_BOUNDS = 'SET_BOUNDS'
export const SET_SHOULD_FIT_TO_PROPERTIES = 'SET_SHOULD_FIT_TO_PROPERTIES'
export const SEARCH_LAYERS_VISIBILITY = 'SEARCH_LAYERS_VISIBILITY'
export const TAX_DETAIL_LAYERS_VISIBILITY = 'TAX_DETAIL_LAYERS_VISIBILITY'
export const TOGGLE_LAYER_VISIBILITY_PANEL = 'TOGGLE_LAYER_VISIBILITY_PANEL'
export const TOGGLE_LEGEND_PANEL = 'TOGGLE_LEGEND_PANEL'
export const TOGGLE_STATUS_FILTERS_PANEL = 'TOGGLE_STATUS_FILTERS_PANEL'
export const TOGGLE_PARCEL_INFO_PANEL = 'TOGGLE_PARCEL_INFO_PANEL'
export const SET_SELECTED_MINI_CARD_DATA = 'SET_SELECTED_MINI_CARD_DATA'
export const SET_DRAWING_MODE = 'SET_DRAWING_MODE'
export const SET_MAP_FALLBACK_MODE = 'SET_MAP_FALLBACK_MODE'

// SEARCH
export const SET_REGION_SEARCH = 'SET_REGION_SEARCH'
export const SET_HOME_PAGE_SEARCH_MODE = 'SET_HOME_PAGE_SEARCH_MODE'
export const SET_ACTIVE_MORE_TAB = 'SET_ACTIVE_MORE_TAB'
export const SET_EXPANDED_TAX_SECTIONS = 'SET_EXPANDED_TAX_SECTIONS'
export const SET_MORE_PRIMARY_RENTALS_EXPANDED =
  'SET_MORE_TAX_PRIMARY_RENTALS_EXPANDED'
export const SET_USER_VIEW_SEARCH_PREFERENCES =
  'SET_USER_VIEW_SEARCH_PREFERENCES'
export const SET_MORE_TAX_ADDRESS_PARCEL_NUMBER_EXPANDED =
  'SET_MORE_TAX_ADDRESS_PARCEL_NUMBER_EXPANDED'

// SIMPLE SEARCH
export const SET_SEARCHING = 'SET_SEARCHING'
export const SET_SEARCH_BOX_TEXT = 'SET_SEARCH_BOX_TEXT'
export const SET_SUGGESTED_PARCELS = 'SET_SUGGESTED_PARCELS'
export const TOGGLE_SEARCH_PROPERTY_STATUS = 'TOGGLE_SEARCH_PROPERTY_STATUS'
export const SET_SEARCH_ACTIVITY_STATUSES = 'SET_SEARCH_ACTIVITY_STATUSES'

// FILTERS
export const SET_FILTER_CRITERIA = 'SET_FILTER_CRITERIA'
export const SET_FILTERS = 'SET_FILTERS'
export const CLEAR_FILTER = 'CLEAR_FILTER'
export const RESET_FILTERS = 'RESET_FILTERS'
export const SET_DEFAULT_FILTER = 'SET_DEFAULT_FILTER'
export const SET_AI_SEARCH = 'SET_AI_SEARCH'
// eslint-disable-next-line operator-linebreak
export const SET_FILTERS_VISIBLE_ON_RESULTS_PAGE =
  'SET_FILTERS_VISIBLE_ON_RESULTS_PAGE'
export const SET_FILTER_GEOMETRY = 'SET_FILTER_GEOMETRY'
export const SET_REGION_FILTERS_VISIBLE = 'SET_REGION_FILTERS_VISIBLE'
export const CLEAR_FILTER_REGIONS = 'CLEAR_FILTER_REGIONS'
export const REMOVE_COMMUTE_FILTER = 'REMOVE_COMMUTE_FILTER'
export const ADD_COMMUTE_FILTER = 'ADD_COMMUTE_FILTER'
export const SET_FILTER_PROPERTIES_ERROR = 'SET_FILTER_PROPERTIES_ERROR'
// COMPARE
export const SET_PROPERTY_COMP_DATA = 'SET_PROPERTY_COMP_DATA'
export const SET_PROPERTY_COMP_LOADING = 'SET_PROPERTY_COMP_LOADING'
export const SET_COMP_SELECTIONS = 'SET_COMP_SELECTIONS'
export const TOGGLE_PANEL = 'TOGGLE_PANEL'
export const SET_LARGE_MAP_VIEW = 'SET_LARGE_MAP_VIEW'
export const SET_COMP_RELOAD = 'SET_COMP_RELOAD'

// PROPERTY EVALUATOR
export const SET_SUBJECT_PROPERTY = 'SET_SUBJECT_PROPERTY'
export const SET_SOLD_COMPS = 'SET_SOLD_COMPS'
export const SET_FORSALE_COMPS = 'SET_FORSALE_COMPS'
export const SET_AVMS = 'SET_AVMS'
export const SET_PROPEVAL_FILTERS = 'SET_PROPEVAL_FILTERS'
export const SET_FOR_SALE_FILTERS = 'SET_FOR_SALE_FILTERS'
export const SET_SOLD_FILTERS = 'SET_SOLD_FILTERS'
export const RESET_FOR_SALE_FILTERS = 'RESET_FOR_SALE_FILTERS'
export const RESET_SOLD_FILTERS = 'RESET_SOLD_FILTERS'
export const SET_PROP_EVAL_HEADER = 'SET_PROP_EVAL_HEADER'
export const RESET_PROP_EVAL = 'RESET_PROP_EVAL'
export const SET_OFFMARKET_COMPS = 'SET_OFFMARKET_COMPS'

// CUSTOM PROPETY EVALUATOR
export const RESET_CUSTOM_PROP_EVAL = 'RESET_CUSTOM_PROP_EVAL'
export const SET_CUSTOM_PROP_EVAL_VIEW = 'SET_CUSTOM_PROP_EVAL_VIEW'
export const SET_CUSTOM_PROP_EVAL_SUBJECT_PROPERTY =
  'SET_CUSTOM_PROP_EVAL_SUBJECT_PROPERTY'
export const SET_CUSTOM_PROP_EVAL_HEADER = 'SET_CUSTOM_PROP_EVAL_HEADER'
export const SET_CUSTOM_PROP_EVAL_SEARCHBOX_TEXT =
  'SET_CUSTOM_PROP_EVAL_SEARCHBOX_TEXT'
export const SET_CUSTOM_PROP_EVAL_SUGGESTIONS =
  'SET_CUSTOM_PROP_EVAL_SUGGESTIONS'
export const SET_CUSTOM_COMPS = 'SET_CUSTOM_COMPS'
export const TOGGLE_CUSTOM_COMP = 'TOGGLE_CUSTOM_COMP'
export const TOGGLE_CUSTOM_PROP_EVAL_SWITCH = 'TOGGLE_CUSTOM_PROP_EVAL_SWITCH'
export const SET_CUSTOM_PROP_EVAL_SUBJECT_PROPERTY_SEARCHBOX_TEXT =
  'SET_CUSTOM_PROP_EVAL_SUBJECT_PROPERTY_SEARCHBOX_TEXT'
export const SET_CUSTOM_AVMS = 'SET_CUSTOM_AVMS'
export const SET_CUSTOM_PROP_EVAL_SOURCE_ACTIVE =
  'SET_CUSTOM_PROP_EVAL_SOURCE_ACTIVE'
export const RESTORE_SAVED_CUSTOM_PROP_EVAL = 'RESTORE_SAVED_CUSTOM_PROP_EVAL'

// UI
export const SCREEN_RESIZE = 'SCREEN_RESIZE'
export const SHOW_SNACKBAR = 'SHOW_SNACKBAR'
export const SET_ITEMS_VIEW = 'SET_ITEMS_VIEW'
export const TOGGLE_MAIN_MENU = 'TOGGLE_MAIN_MENU'
export const TOGGLE_AGENT_DRAWER = 'TOGGLE_AGENT_DRAWER'
export const TOGGLE_LIGHTBOX = 'TOGGLE_LIGHTBOX'
export const TOGGLE_REGISTER_LOGIN = 'TOGGLE_REGISTER_LOGIN'
export const TOGGLE_DATA_VIEW = 'TOGGLE_DATA_VIEW'
export const SET_MODAL = 'SET_MODAL'
export const TOGGLE_PRINT_PANE = 'TOGGLE_PRINT_PANE'
export const SET_COMPARE_VIEW = 'SET_COMPARE_VIEW'
export const EXPAND_CARD = 'EXPAND_CARD'
export const SET_PROCESSING = 'SET_PROCESSING'
export const TOGGLE_MOBILE_NAV_DRAWER = 'TOGGLE_MOBILE_NAV_DRAWER'
export const SET_TYPEAHEAD_NO_CONTACTS_FOUND = 'SET_TYPEAHEAD_NO_CONTACTS_FOUND'
export const SET_NAME_FOR_DOCUMENT_TITLE = 'SET_NAME_FOR_DOCUMENT_TITLE'
export const TRIGGER_SUBSCRIBER_WELCOME_MODAL =
  'TRIGGER_SUBSCRIBER_WELCOME_MODAL'
export const SET_BLADE_EXPANDED = 'SET_BLADE_EXPANDED'
export const SET_HAVE_ZIP_ON_TAX_DETAIL = 'SET_HAVE_ZIP_ON_TAX_DETAIL'
export const SHOW_PROPERTY_ACTIONS_SHEET = 'SHOW_PROPERTY_ACTIONS_SHEET'
export const HIDE_PROPERTY_ACTIONS_SHEET = 'HIDE_PROPERTY_ACTIONS_SHEET'

// AUTH0
export const SET_AUTH0_USER = 'SET_AUTH0_USER'
export const SET_CURBVIEW_ADMIN = 'SET_CURBVIEW_ADMIN'

// USER
export const DELETE_SEARCH = 'DELETE_SEARCH'
export const SAVING_SEARCH = 'SAVING_SEARCH'
export const SET_SAVED_SEARCH = 'SET_SAVED_SEARCH'
export const SET_SAVED_SEARCH_NAME = 'SET_SAVED_SEARCH_NAME'
export const SET_SAVED_SEARCH_RESPONSE = 'SET_SAVED_SEARCH_RESPONSE'
export const SET_SAVED_SEARCH_MODAL_OPEN = 'SET_SAVED_SEARCH_MODAL_OPEN'
export const SET_SEARCH_NAME = 'SET_SEARCH_NAME'
export const SET_AGENT = 'SET_AGENT'
export const SET_SAVED_PROPERTY_RESPONSE = 'SET_SAVED_PROPERTY_RESPONSE'
export const SET_USER_SAVED_PROPERTIES = 'SET_USER_SAVED_PROPERTIES'
export const SET_USER_DATA_LOADED = 'SET_USER_DATA_LOADED'
export const SET_FAV_PROPERTY = 'SET_FAV_PROPERTY'
export const SET_HIDDEN_PROPERTY = 'SET_HIDDEN_PROPERTY'
export const SET_NEUTRAL_PROPERTY = 'SET_NEUTRAL_PROPERTY'
export const SET_USER_SAVED_LISTS = 'SET_USER_SAVED_LISTS'
export const SET_PROPERTY_DETAILS_GROUP = 'SET_PROPERTY_DETAILS_GROUP'
export const SET_PROPERTY_MEDIA_VIEW = 'SET_PROPERTY_MEDIA_VIEW'
export const SET_NAVIGATION = 'SET_NAVIGATION'
export const SET_SELECTED_LIST = 'SET_SELECTED_LIST'
export const REMOVE_ITEM_FROM_LIST = 'REMOVE_ITEM_FROM_LIST'
export const REMOVE_ITEM_FROM_SELECTED_LIST = 'REMOVE_ITEM_FROM_SELECTED_LIST'
export const ADD_ITEM_TO_SELECTED_LIST = 'ADD_ITEM_TO_SELECTED_LIST'
export const SET_POI = 'SET_POI'
export const SET_POIS = 'SET_POIS'
export const SET_POIS_LOADING = 'SET_POIS_LOADING'
export const SET_POI_PROXIMITY = 'SET_POI_PROXIMITY'
export const SET_USER_STATS = 'SET_USER_STATS'
export const SET_USER_CREATED_IN_MONGO = 'SET_USER_CREATED_IN_MONGO'
export const SET_ARMLS_LOGON_TYPE = 'SET_ARMLS_LOGON_TYPE'
export const SET_USER_CONNECTED_TO_AGENT = 'SET_USER_CONNECTED_TO_AGENT'
export const SET_USER_CONNECTED_TO_NETWORK = 'SET_USER_CONNECTED_TO_NETWORK'
export const SET_USER_AGENTS = 'SET_USER_AGENTS'
export const SET_USER_PREFERENCE = 'SET_USER_PREFERENCE'
export const SET_VIEWED_AGENT_SELECTOR = 'SET_VIEWED_AGENT_SELECTOR'
export const SET_SHOW_FIRST_LOGIN_HELP = 'SET_SHOW_FIRST_LOGIN_HELP'

export const SET_PROPERTY_SHARE_LOOKUP = 'SET_PROPERTY_SHARE_LOOKUP'
export const SET_PROPERTY_SHARE_SUGGESTIONS = 'SET_PROPERTY_SHARE_SUGGESTIONS'
export const ADD_PROPERTY_SHARE_RECIPIENT = 'ADD_PROPERTY_SHARE_RECIPIENT'
export const SET_PROPERTY_SHARE_RECIPIENTS = 'SET_PROPERTY_SHARE_RECIPIENTS'
export const SET_PROPERTY_SHARE_LOOKUP_SEARCHID =
  'SET_PROPERTY_SHARE_LOOKUP_SEARCHID'
export const SET_RESOURCE_SHARE_LOOKUP = 'SET_RESOURCE_SHARE_LOOKUP'
export const SET_RESOURCE_SHARE_SUGGESTIONS = 'SET_RESOURCE_SHARE_SUGGESTIONS'
export const ADD_RESOURCE_SHARE_RECIPIENT = 'ADD_RESOURCE_SHARE_RECIPIENT'
export const SET_RESOURCE_SHARE_RECIPIENTS = 'SET_RESOURCE_SHARE_RECIPIENTS'
export const SET_RESOURCE_SHARE_LOOKUP_SEARCHID =
  'SET_RESOURCE_SHARE_LOOKUP_SEARCHID'
export const SET_USER_PROFILE_IMAGE = 'SET_USER_PROFILE_IMAGE'
export const CLEAR_USER_PROFILE_IMAGE = 'CLEAR_USER_PROFILE_IMAGE'
export const SET_JUST_LOGGED_IN = 'SET_JUST_LOGGED_IN'
export const SET_USER_FLEX_DATA = 'SET_USER_FLEX_DATA'
export const SET_USER_PERMISSIONS = 'SET_USER_PERMISSIONS'
export const SET_USER_NETWORK_FAVORITES = 'SET_USER_NETWORK_FAVORITES'
export const SET_REGISTERED_GUEST_DEMOGRAPHICS =
  'SET_REGISTERED_GUEST_DEMOGRAPHICS'
export const SET_FEATURE_PERMISSIONS = 'SET_FEATURE_PERMISSIONS'

// NETWORKS
export const UPDATE_NETWORKS = 'UPDATE_NETWORKS'
export const SET_SELECTED_NETWORK = 'SET_SELECTED_NETWORK'
export const SET_NETWORK_NAMES = 'SET_NETWORK_NAMES'
export const SET_SHARED_NETWORK_NAMES = 'SET_SHARED_NETWORK_NAMES'
export const SET_NETWORK = 'SET_NETWORK'
export const SET_NETWORK_ACTIVITY_FILTER = 'SET_NETWORK_ACTIVITY_FILTER'

// CONTACTS
export const SET_CONTACTS = 'SET_CONTACTS'
export const SET_CONTACT = 'SET_CONTACT'
export const SET_CONTACT_TAGS = 'SET_CONTACT_TAGS'

// CONTEXT PROVIDER
export const SET_CONTEXT = 'SET_CONTEXT'
export const REFRESH_CONTEXT_SCREEN = 'REFRESH_CONTEXT_SCREEN'
export const SET_REFRESH_SCREEN = 'SET_REFRESH_SCREEN'
export const SET_USER_VIEW_CONTEXT_PREFERENCES =
  'SET_USER_VIEW_CONTEXT_PREFERENCES'

// UI
export const SET_THEME = 'SET_THEME'
export const SET_SHOW_IDX_SELECTOR = 'SET_SHOW_IDX_SELECTOR'
export const SET_USER_TAB = 'SET_USER_TAB'
export const SET_MAP_WIDTH = 'SET_MAP_WIDTH'
export const SET_FEATURE_FLAGS = 'SET_FEATURE_FLAGS'
export const PUSH_ROUTE = 'PUSH_ROUTE' // for map.lastKnownBounds restoration

// TYPEAHEAD
export const SET_TYPEAHEAD_QUERY = 'SET_TYPEAHEAD_QUERY'
export const SET_TYPEAHEAD_SUGGESTIONS = 'SET_TYPEAHEAD_SUGGESTIONS'
export const SET_TYPEAHEAD_SELECTED_ITEM = 'SET_TYPEAHEAD_SELECTED_ITEM'
export const REMOVE_TYPEAHEAD_KEY = 'REMOVE_TYPEAHEAD_KEY'

// API
export const SET_LISTINGS_DATA_NEAR_PARCEL_CACHE =
  'SET_LISTINGS_DATA_NEAR_PARCEL_CACHE'

// HISTORY LISTENER
export const ADD_HISTORY = 'ADD_HISTORY'
export const POP_HISTORY = 'POP_HISTORY'
export const UPDATE_HISTORY_WITH_LABEL = 'UPDATE_HISTORY_WITH_LABEL'
export const SET_HISTORY_CURSOR = 'SET_HISTORY_CURSOR'
export const SLICE_HISTORY_AT_CURSOR = 'SLICE_HISTORY_AT_CURSOR'
export const REMOVE_LAST_HISTORY_ITEM = 'REMOVE_LAST_HISTORY_ITEM'

// ERRORS
export const API_ERROR = 'API_ERROR'
export const CLEAR_ERRORS = 'CLEAR_ERRORS'

// SHARES
export const SET_ACTIVE_SHARE = 'SET_ACTIVE_SHARE'

// TOURS
export const SET_TOUR = 'SET_TOUR'

// TAX DETAIL
export const TAX_SELECT_ALL_ACTIVITY_STATUSES =
  'TAX_SELECT_ALL_ACTIVITY_STATUSES'
export const TAX_DESELECT_ALL_ACTIVITY_STATUSES =
  'TAX_DESELECT_ALL_ACTIVITY_STATUSES'
export const TAX_BULK_SET_ACTIVITY_STATUSES = 'TAX_BULK_SET_ACTIVITY_STATUSES'
export const TAX_SET_ACTIVITY_MONTHS = 'TAX_SET_ACTIVITY_MONTHS'
export const TAX_SET_ACTIVITY_FORSALE_RENT = 'TAX_SET_ACTIVITY_FORSALE_RENT'
export const TAX_FILTERS_CHANGED = 'TAX_FILTERS_CHANGED'
export const TAX_RESET_ACTIVITY_FILTERS = 'TAX_RESET_ACTIVITY_FILTERS'
export const TAX_INCLUDE_FORECLOSURE_STATUS = 'TAX_INCLUDE_FORECLOSURE_STATUS'
export const TAX_TOGGLE_ACTIVITY_STATUS = 'TAX_TOGGLE_ACTIVITY_STATUS'
